import numeral from 'numeral';

numeral.register('locale', 'es', {
  delimiters: {
      thousands: '.',
      decimal: ','
  },
  abbreviations: {
      thousand: 'm',
      million: 'M',
      billion: 'b',
      trillion: 't'
  },
  ordinal : function (number) {
      return number === 1 ? 'un' : 'uno';
  },
  currency: {
      symbol: '$'
  }
});

// switch between locales
numeral.locale('es');